export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtPOVVaria';
export const NAME = 'ZarazeniPov';
